export default __webpack_public_path__ + "static/media/5.2b102b6f.webp";